export const aciCoffe = {
    iconName: 'coffe',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M9.14 3c-1.143 1.143 1.143 1.714 0 2.857M12 3c-1.143 1.143 1.143 1.714 0 2.857M14.856 3c-1.143 1.143 1.143 1.714 0 2.857M16.829 15.008C18.756 15.53 20 16.356 20 17.286c0 1.578-3.581 2.857-8 2.857-4.42 0-8-1.28-8-2.857 0-.93 1.244-1.753 3.17-2.278',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M6.856 10.429c-.571 4 .905 5.714.905 5.714.238.571 1.898 1.714 4.238 1.714 2.34 0 4-1.143 4.239-1.714 0 0 1.476-1.714.904-5.714',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M6.857 10.428c0 .607.542 1.188 1.507 1.617.964.428 2.272.67 3.636.67 1.364 0 2.672-.242 3.637-.67.964-.429 1.506-1.01 1.506-1.617 0-.606-.542-1.187-1.506-1.616-.965-.428-2.273-.67-3.637-.67-1.364 0-2.672.242-3.636.67-.965.429-1.507 1.01-1.507 1.617z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M8.183 11.96l.389-.389A5.006 5.006 0 0112 10.43a5.006 5.006 0 013.429 1.143l.388.388',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
